import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { ContentProvider } from "@/contexts/ContentContext";
import { PagesProvider } from "@/contexts/PagesContext";
import ThemeChooser from "@/components/ThemeChooser";
import Landing from "@/pages/Landing";
import ManageAppointment from "@/pages/ManageAppointment";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";
import CategoryPage from "@/pages/CategoryPage";
import CollectionsPage from "@/pages/CollectionsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AppointmentPage from "@/pages/AppointmentPage";
import BlogList from "@/pages/BlogList";
import BlogDetail from "@/pages/BlogDetail";
import DynamicPage from "@/pages/DynamicPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <ContentProvider>
            <SettingsProvider>
              <AuthProvider>
                <BrowserRouter>
                  <PagesProvider>
                  <Toaster position="top-center" theme="dark" richColors />
                  <ThemeChooser />
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/collecties" element={<CollectionsPage />} />
                    <Route path="/collectie/:category" element={<CategoryPage />} />
                    <Route path="/over-ons" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/termin" element={<AppointmentPage />} />
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/meine-termine" element={<ManageAppointment />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/reset-password" element={<ResetPassword />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/:slug" element={<DynamicPage />} />
                  </Routes>
                  </PagesProvider>
                </BrowserRouter>
              </AuthProvider>
            </SettingsProvider>
          </ContentProvider>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
